document.addEventListener('DOMContentLoaded', function() {
  const loadingScreen = document.getElementById('loading-screen');
  const mainSite = document.getElementById('main-site');
  
  if (!loadingScreen || !mainSite) return;
  
  const hasSeenLoading = sessionStorage.getItem('hasSeenLoadingScreen');
  
  if (!hasSeenLoading) {
    const loadingBar = document.getElementById('loading-bar');
    const statusMessage = document.getElementById('status-message');
    const protocolText = document.getElementById('protocol-text');
    
    const protocolLines = [
      ">_ initiating dripling protocol v2.3",
      ">_ system boot sequence...",
      ">_ establishing neural link...",
      ">_ dripling harvest sequence initiated",
      ">_ [REDACTED]",
      ">_ i̸t̵ ̵h̷u̶r̵t̷s̵ ̷t̸o̶ ̵s̵e̸e̶",
      ">_ please go away",
      ">_ preparing interface"
    ];
    
    // Display protocol lines
    protocolLines.forEach((line, index) => {
      const div = document.createElement('div');
      div.className = 'protocol-line' + (Math.random() > 0.7 ? ' glitch' : '');
      div.textContent = line;
      protocolText.appendChild(div);
    });
    
    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 15;
      
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
        
        setTimeout(() => {
          loadingScreen.style.opacity = '0';
          mainSite.style.display = 'block';
          
          setTimeout(() => {
            loadingScreen.style.display = 'none';
          }, 500);
          
          sessionStorage.setItem('hasSeenLoadingScreen', 'true');
        }, 500);
      }
      
      loadingBar.style.width = progress + '%';
      
      if (Math.random() > 0.7) {
        const randomLine = protocolLines[Math.floor(Math.random() * protocolLines.length)];
        statusMessage.textContent = randomLine.substring(3);
      }
    }, 100);
  } else {
    loadingScreen.style.display = 'none';
    mainSite.style.display = 'block';
  }
  
  // Mobile Menu Toggle
  window.toggleMenu = function() {
    const nav = document.getElementById('main-nav');
    nav.classList.toggle('active');
  };
});